import 'es6-promise/auto'
import { debounce, isEmpty } from '~/misc/Utils'
import Contact from '~/components/Contact'
import FileUpload from '~/components/FileUpload'

class App {
    constructor() {
        this.reloaders = []
        this.init()
        this.initResize()
    }

    init() {
        new Contact()
        new FileUpload()
    }

    initResize() {
        if (!isEmpty(this.reloaders)) {
            window.addEventListener(
                'resize',
                debounce(() => {
                    this.resize()
                }, 150),
                false
            )
        }
    }

    resize() {
        this.reloaders.forEach((element) => {
            if (typeof element.resize === 'function') {
                element.resize()
            }
        })
    }
}

new App()
